import ViewPadrao from "../views/ViewPadrao";
import ContasReceberList from "../views/ContasReceberList";
import ContasReceberCad from "../views/ContasReceberCad";

export default {
  path: "contas-receber",
  component: ViewPadrao,
  children: [
    {
      path: "lista",
      name: "contas-receber-list",
      component: ContasReceberList,
    },
    {
      path: "novo",
      name: "contas-receber-formulario",
      component: ContasReceberCad,
    },
    {
      path: "editar/:id",
      name: "contas-receber-editar",
      component: ContasReceberCad,
    },
  ],
};
